/*
  pmf-blog.js — Interactions de la page liste du blog PrepMyFuture.
  100 % côté client, sans rechargement de page. Vanilla JS, aucune dépendance.

  État : activeTag, sort ('recent'|'popular'), query, visibleCount, featuredIndex.
  Le filtre/tri/recherche agit UNIQUEMENT sur la grille ; la section « À la une »
  reste éditoriale et stable.
*/
(function () {
  'use strict';

  function initBlog(root) {
    if (!root || root.dataset.pmfInit === 'true') return;
    root.dataset.pmfInit = 'true';

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var grid = root.querySelector('[data-pmf-grid]');
    var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-pmf-card]')) : [];
    var countEl = root.querySelector('[data-pmf-count]');
    var sortByEl = root.querySelector('[data-pmf-sortby]');
    var moreWrap = root.querySelector('[data-pmf-more]');
    var moreBtn = root.querySelector('[data-pmf-more-btn]');
    var moreLabel = root.querySelector('[data-pmf-more-label]');
    var emptyEl = root.querySelector('[data-pmf-empty]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-pmf-tag]'));
    var searchInput = root.querySelector('[data-pmf-search]');
    var sortBtns = Array.prototype.slice.call(root.querySelectorAll('[data-pmf-sort]'));

    var perLoad = parseInt(root.dataset.pmfPerLoad, 10) || 6;
    var step = parseInt(root.dataset.pmfStep, 10) || 3;

    // i18n : libellés injectés par la section (avec repères {n}, {tag}, {query}).
    var i18n = {};
    try { i18n = JSON.parse(root.dataset.pmfStrings || '{}'); } catch (e) { i18n = {}; }
    function t(key, fallback) { return (i18n[key] != null) ? i18n[key] : fallback; }
    function fmt(str, vars) {
      return String(str).replace(/\{(\w+)\}/g, function (_, k) {
        return (vars[k] != null) ? vars[k] : '';
      });
    }

    var state = {
      activeTag: 'tous',
      sort: 'recent',
      query: '',
      visible: perLoad
    };

    /* ---------- Grille : filtre → tri → tranche ---------- */
    function computeList() {
      var q = state.query.trim().toLowerCase();
      var list = cards.filter(function (c) {
        var tags = (c.dataset.tags || '').split(',');
        var tagOk = state.activeTag === 'tous' || tags.indexOf(state.activeTag) !== -1;
        if (!tagOk) return false;
        if (!q) return true;
        var hay = (c.dataset.title || '') + ' ' + (c.dataset.tags || '');
        return hay.indexOf(q) !== -1;
      });
      list.sort(function (a, b) {
        if (state.sort === 'popular') {
          return (parseFloat(b.dataset.pop) || 0) - (parseFloat(a.dataset.pop) || 0);
        }
        return (parseFloat(b.dataset.date) || 0) - (parseFloat(a.dataset.date) || 0);
      });
      return list;
    }

    function apply(animateNew) {
      var list = computeList();
      var total = list.length;

      // tout masquer, puis afficher la tranche visible dans le bon ordre
      cards.forEach(function (c) {
        c.style.display = 'none';
        c.classList.remove('is-entering');
      });
      list.forEach(function (c, i) {
        c.style.order = i;
        if (i < state.visible) {
          var wasHidden = c.dataset.pmfShown !== 'true';
          c.style.display = '';
          c.dataset.pmfShown = 'true';
          if (animateNew && wasHidden && !reduce) c.classList.add('is-entering');
        } else {
          c.dataset.pmfShown = 'false';
        }
      });

      updateCount(total);
      updateMore(total);
      updateEmpty(total);
    }

    function updateCount(total) {
      if (!countEl) return;
      var label;
      var q = state.query.trim();
      if (q) {
        label = fmt(t('results', '{n} résultats pour « {query} »'), { n: total, query: q });
        if (total <= 1) label = fmt(t('results_one', '{n} résultat pour « {query} »'), { n: total, query: q });
      } else if (state.activeTag !== 'tous') {
        var tagName = tagDisplayName(state.activeTag);
        label = fmt(total <= 1 ? t('count_one_tag', '{n} article · {tag}') : t('count_tag', '{n} articles · {tag}'),
          { n: total, tag: tagName });
      } else {
        label = fmt(total <= 1 ? t('count_one', '{n} article') : t('count', '{n} articles'), { n: total });
      }
      countEl.textContent = label;
    }

    function tagDisplayName(slug) {
      var chip = chips.filter(function (c) { return c.dataset.pmfTag === slug; })[0];
      return chip ? (chip.dataset.pmfTagLabel || chip.textContent.trim()) : slug;
    }

    function updateMore(total) {
      if (!moreWrap) return;
      var remaining = Math.max(0, total - state.visible);
      if (remaining > 0) {
        moreWrap.hidden = false;
        if (moreLabel) {
          moreLabel.textContent = fmt(remaining <= 1 ? t('remaining_one', '{n} article restant') : t('remaining', '{n} articles restants'),
            { n: remaining });
        }
      } else {
        moreWrap.hidden = true;
      }
    }

    function updateEmpty(total) {
      if (emptyEl) emptyEl.hidden = total !== 0;
      if (grid) grid.style.display = total === 0 ? 'none' : '';
    }

    /* ---------- Événements grille ---------- */
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        state.activeTag = chip.dataset.pmfTag;
        state.visible = perLoad;
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        apply(false);
      });
    });

    sortBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.sort = btn.dataset.pmfSort;
        sortBtns.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (sortByEl) {
          sortByEl.textContent = state.sort === 'popular'
            ? t('sort_popular', 'Populaires')
            : t('sort_recent', 'Plus récents');
        }
        apply(false);
      });
    });

    if (searchInput) {
      var debounce;
      searchInput.addEventListener('input', function () {
        clearTimeout(debounce);
        var val = searchInput.value;
        debounce = setTimeout(function () {
          state.query = val;
          state.visible = perLoad;
          apply(false);
        }, 120);
      });
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        state.visible += step;
        apply(true);
      });
    }

    /* ---------- Slider « À la une » ---------- */
    var featWrap = root.querySelector('[data-pmf-featured]');
    if (featWrap) {
      var heroSlot = featWrap.querySelector('[data-pmf-hero-slot]');
      var heroes = Array.prototype.slice.call(featWrap.querySelectorAll('[data-pmf-hero]'));
      var railItems = Array.prototype.slice.call(featWrap.querySelectorAll('[data-pmf-rail-item]'));
      var dots = Array.prototype.slice.call(featWrap.querySelectorAll('[data-pmf-dot]'));
      var prevBtn = featWrap.querySelector('[data-pmf-prev]');
      var nextBtn = featWrap.querySelector('[data-pmf-next]');
      var featIndex = 0;
      var count = heroes.length;
      var fadeTimer;

      function showFeatured(i) {
        if (count === 0) return;
        var idx = ((i % count) + count) % count;
        if (idx === featIndex) return;

        function swap() {
          heroes.forEach(function (h, n) { var on = n === idx; h.hidden = !on; h.style.display = on ? '' : 'none'; });
          railItems.forEach(function (r, n) {
            var on = n === idx;
            r.classList.toggle('is-active', on);
            r.setAttribute('aria-current', on ? 'true' : 'false');
          });
          dots.forEach(function (d, n) {
            var on = n === idx;
            d.classList.toggle('is-active', on);
            d.setAttribute('aria-current', on ? 'true' : 'false');
          });
          featIndex = idx;
        }

        if (reduce || !heroSlot) {
          swap();
        } else {
          heroSlot.classList.add('is-fading');
          clearTimeout(fadeTimer);
          fadeTimer = setTimeout(function () {
            swap();
            heroSlot.classList.remove('is-fading');
          }, 165);
        }
      }

      railItems.forEach(function (item, n) {
        item.addEventListener('click', function () { showFeatured(n); });
      });
      dots.forEach(function (dot, n) {
        dot.addEventListener('click', function () { showFeatured(n); });
      });
      if (prevBtn) prevBtn.addEventListener('click', function () { showFeatured(featIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { showFeatured(featIndex + 1); });
      // Pas d'auto-défilement (choix éditorial + a11y).
    }

    /* ---------- Init ---------- */
    apply(false);
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-pmf-blog]')).forEach(initBlog);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Ré-initialisation dans l'éditeur de thème Shopify (Section Rendering).
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-pmf-blog]');
    if (el) initBlog(el);
  });
})();
